import { LogRegLogo } from "../util/LogRegLogo";
import Tos from "./Tos";
import React from "react";
import googleImg from './icons/google.png';
import { ReactComponent as MicrosoftIcon } from './icons/microsoft.svg';
import mailImg from './icons/mail.png';
import GoogleAuthButton from "../login/GoogleAuthButton";
import { useMicrosoftAuth } from "../login/MicrosoftAuthButton";
import { SsoMember } from "../../generated/dashboard-client";
import { Spinner } from "../account/misc/Spinner";

export interface RegOrLoginDecision {
  gMember?: SsoMember;
  type: 'email' | 'google' | 'microsoft'
}

export interface RegStepZeroProps {
  onDecision: (decision: RegOrLoginDecision) => void;
  loading: boolean;
  onStartLoading: () => void;
  error?: string;
  onError?: (message: string) => void;
}

export default function RegStepZero({ onDecision, loading, onStartLoading, error, onError }: RegStepZeroProps) {
  const urlParams = new URLSearchParams(window.location.search);
  const source = urlParams.get('source') || '';

  function onEmailClick() {
    onDecision({ type: 'email' });
  }

  async function onGoogleRegister(gMember: SsoMember) {
    onDecision({ type: 'google', gMember });
  }

  async function onMicrosoftRegister(gMember: SsoMember) {
    onDecision({ type: 'microsoft', gMember });
  }

  const { loginWithMicrosoft } = useMicrosoftAuth({
    onSuccess: onMicrosoftRegister,
    onStartLoading,
    onError
  });

  return (
    <div className={"step-type step full"}>
      <LogRegLogo />
      {source === 'popmenu'
        ? <h2>Create your account</h2>
        : <h2>Login or sign up in seconds</h2>
      }
      {source === 'popmenu'
        ? <h5>Please register to make your menu items available for use on MustHaveMenus.</h5>
        : <h5>Use your email, Google, or Microsoft to continue with MustHaveMenus.</h5>
      }

      {loading && <Spinner />}
      {error && <p className="sso-error" style={{color: "#ff4d4f", textAlign: "center", marginBottom: 16}}>{error}</p>}
      {!loading && <div className="login-buttons">
        <div>
          <img src={googleImg} alt="Google" />
          <span className={'login-option'}>Continue with Google</span>
          <GoogleAuthButton hidden onSuccess={onGoogleRegister} onStartLoading={onStartLoading} />
        </div>
        <div onClick={loginWithMicrosoft}>
          <MicrosoftIcon />
          <span className={'login-option'}>Continue with Microsoft</span>
        </div>
        <div onClick={onEmailClick}>
          <img src={mailImg} alt="Email" />
          <span className={'login-option'}>Continue with Email</span>
        </div>
      </div>}
      <Tos />
    </div>
  );
}
